module.exports = __webpack_public_path__ + "img/home-empresas-3.c8826a2.png";